import { render, staticRenderFns } from "./ViewArticleJobCategoryList.vue?vue&type=template&id=837e9a0a&"
import script from "./ViewArticleJobCategoryList.vue?vue&type=script&lang=js&"
export * from "./ViewArticleJobCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports